import zhTW from "antd/lib/locale/zh_TW";
import enUS from "antd/locale/en_US";
import idID from "antd/locale/id_ID";
import thTH from "antd/locale/th_TH";
import viVN from "antd/locale/vi_VN";
import zhCN from "antd/locale/zh_CN";

// import thTH from "antd/locale/id_ID";

const packageLan = {
  "en-US": enUS,
  "zh-TW": zhTW,
  "zh-CN": zhCN,
  "vi-VN": viVN,
  "id-ID": idID,
  "th-TH": thTH,
};

export default packageLan;
